import * as t from "io-ts";

import { allC } from "./filter";

export const recipientTypeC = t.union([allC, t.literal("user"), t.literal("contact")]);
export type RecipientType = t.TypeOf<typeof recipientTypeC>;
